const defaultSettings = require('../settings')
// 本地环境配置
module.exports = {
  title: defaultSettings.title || 'xxh-zhaopin-web',
  port: 9018, // 端口
  baseFileUrl: 'http://localhost:9018', // 文件服务
  baseUrl: 'http://localhost:9018', // 项目地址
  // baseApi: 'http://localhost:9018'
  // baseApi: 'http://192.168.28.27:8080/'
  // baseApi: 'http://192.168.28.155:8082' // 赵浩然
  // baseApi: 'https://pre-ihire.dhrforce.com/xxh-zhaopin-web/',
  // baseApi: 'http://192.168.29.194:8080/', // 姬婷方
  loginUrl: 'https://preportal.dhrforce.com',
  baseApi: 'https://preapi.dhrforce.com/',
  baseApi1: 'https://pre-ihire.dhrforce.com',
  referralPth: 'https://pre-ihire.dhrforce.com/referral',
  referralH5Path:'https://pre-ihire-app.dhrforce.com/referral', // 内推H5
  extrapolationH5Path: 'https://pre-ihire-app.dhrforce.com/extrapolation', // 外推H5
  extrapolationPCPath: 'https://pre-ihire.dhrforce.com/extrapolation', // 外推pc
  recruitPath: 'https://pre-ihire-app.dhrforce.com', // 招聘助手H5
  filePathPrefix: 'https://zzp-public-1318723636.cos.ap-shanghai.myqcloud.com', // 文件地址前缀
  campusAmbassadorPCPath: 'https://pre-ihire.dhrforce.com/campusAmbassador', // 校园大使PC
  campusAmbassadorH5Path: 'https://pre-ihire-app.dhrforce.com/campusAmbassador' // 校园大使H5
}
